import {
	blue,
	green
} from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/colors";
import {
	fontSize24,
	gridGutterHalf,
	gridGutter1q3,
	gridGutter,
	gridGutter1q6
} from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/layout";

export const wrapper = (hasTwoButtons) => `
    header {
        text-align: center;
        margin-top: -${gridGutterHalf}px;

        i {
            color: ${blue};
            font-size: ${fontSize24};
            margin-bottom: ${gridGutter1q3}px;
            display: block;
        }
    }

    .content {
        min-height: ${hasTwoButtons ? 227 : 270}px;
        max-height: ${hasTwoButtons ? 227 : 270}px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        margin-bottom: ${gridGutterHalf}px;

        .my-input-class {
            margin-bottom: ${gridGutter1q6}px;
        }
    }

    footer {
        a {
            display: block;
            padding-top: ${gridGutter}px;
            text-align: center;
            font-weight: bold;
            color: ${green};
        }
    }
`;
